import { SVGAttributes, VFC } from "react";

/* eslint-disable react/require-default-props */
const ChevronRight: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.86339 1.46973L12.3937 8.00006L5.86339 14.5304L4.80273 13.4697L10.2724 8.00006L4.80273 2.53039L5.86339 1.46973Z"
        fillOpacity="0.75"
      />
    </svg>
  );
};

export { ChevronRight };
